module.exports = __webpack_public_path__ + "static/media/Brayan.cdcfc2ff.png";